import React from "react";
import Header from "../Header/Header";
import Hero from "../Hero Section/Hero";

const HeroMain = () => {


  return (
    <>
      <div className=' hero-main  bg-cover h-content xl:h-screen '>
        <Header />
        <Hero />
      </div>
    </>
  );
};

export default HeroMain;
